import { VStack, type StackProps } from '@chakra-ui/react';

/**
 * The grey box a dialog says its consequences in.
 *
 * Set apart from the fields rather than trailing them as another line of muted text: what it holds
 * is what will be true after the press, which a reader skims past when it looks like a caption.
 * Taken from the indefinite-access confirmation, where the shape was already in use.
 */
const SubtleNote = (props: StackProps) => (
	<VStack align="stretch" gap={1.5} bg="surface.subtle" borderRadius="2xl" px={4} py={4} {...props} />
);

export default SubtleNote;
